export default import.meta.glob('./**/*.vue', { import: 'default' })
